import routeName from '../constant';
import { guideRoutes } from '@/utils/guideRoutes';

const routes = [{
    path: 'policy-contact',
    name: routeName.PROPOSER_INFO,
    component: () => import('@/views/aplCatl640and631/BCBD/landingPage/Index.vue'),
    meta: { auth: true, metaTitle: '地址/電話/Email變更', leaveAlert: true, code: 'BC', unableBack: true },
},
{
    path: 'policy-contact-notify',
    name: routeName.NOTIFY_COMPANIES,
    component: () => import('@/views/aplCatl640and631/BCBD/notifyCompanies/Index.vue'),
    meta: { auth: true, metaTitle: '地址/電話/Email變更', leaveAlert: true, code: 'BC', unableBack: true },
    beforeEnter: (to, from, next) => {
        const whiteList = [routeName.PROPOSER_INFO];
        const guideRoute = guideRoutes(from, whiteList, true);
        next(guideRoute);
    },
}];

export default routes;
